import { gql } from '@apollo/client';

export const postCtaPersonaJuridica = gql`
mutation ctaPersonaJuridicaRQ{
    ctaPersonaJuridica(input:$input)  
    @rest(type: "ctaPersonaJuridicaRS", path: "/api/gateway/motorweb/formulario-cuentajuridica",method:"POST"){
            token 
            nroSolicitud    
    }
}
`